import React from "react";
import Header from "./Header";
import CustomParticles from "./Particles";
import resume from "../takahiro_hiroshi.pdf";
import CloudDownload from "@material-ui/icons/CloudDownload";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(16),
  },
  download: {
    position: "absolute",
    top: 100,
    right: 30,
    color: "white",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      transform: "scale(1.05)",
      transition: "all .5s ease-in-out",
    },
  },
  heading: {
    color: "#e0e0e0",
  },
  avatar: {
    width: "100%",
    height: "100%",
  },
  white: {
    color: "white"
  }
}));

const Home = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className="home-background"/>
      <Header />
      <a download="Resume" href={resume} className={classes.download}>
        RESUME
        <IconButton className={classes.white}>
          <CloudDownload fontSize={"large"} />
        </IconButton>
      </a>
      <CustomParticles />
    </React.Fragment>
  );
};

export default Home;
